import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function FarmerHarvestEstimateDetail() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const data = useSelector((state) => state.harvestEstimate.data);
  const vegetable = useSelector((state) => state.vegetable.data);
  const farmer = useSelector((state) => state.farmer.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerId: "",
    estimateCode: "",
    vegetableId: "",
    plantingDate: "",
    estimatedDate: "",
    amountEstimated: "",
    plantingArea: "",
  });
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      let x = data.docs.findIndex((item) => item._id === id);
      if (x !== -1) {
        setFormData({
          farmerId: data.docs[x].farmerId ? data.docs[x].farmerId._id : "",
          farmerName: data.docs[x].farmerId
            ? data.docs[x].farmerId.fullName
            : "",
          estimateCode: data.docs[x].estimateCode
            ? data.docs[x].estimateCode
            : "",
          vegetableId: data.docs[x].vegetableId
            ? data.docs[x].vegetableId._id
            : "",
          vegetableName: data.docs[x].vegetableId
            ? data.docs[x].vegetableId.vegetableName
            : "",
          plantingDate: data.docs[x].plantingDetails.plantingDate
            ? data.docs[x].plantingDetails.plantingDate
            : "",
          estimatedDate: data.docs[x].plantingDetails.estimatedDate
            ? data.docs[x].plantingDetails.estimatedDate
            : "",
          amountEstimated: data.docs[x].plantingDetails.amountEstimated
            ? data.docs[x].plantingDetails.amountEstimated
            : "",
          plantingArea: data.docs[x].plantingDetails.plantingArea
            ? data.docs[x].plantingDetails.plantingArea
            : "",
        });
      }
      setFetch(false);
    }
  }, [fetch]);

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          DETAIL ESTIMASI PANEN
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE ESTIMASI
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 20,
                style: { background: "white" },
                readOnly: true,
              }}
              required
              helperText={
                formData.estimateCode.length > 0
                  ? /^[A-Za-z]{3}-\d{5}/.test(formData.estimateCode)
                    ? ""
                    : "*Format Kode Estimasi salah"
                  : ""
              }
              size="small"
              error={
                formData.estimateCode.length > 0
                  ? /^[A-Za-z]{3}-\d{5}/.test(formData.estimateCode)
                    ? false
                    : true
                  : false
              }
              name="estimateCode"
              value={formData.estimateCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.farmerName && formData.farmerId.length > 0 && (
                <MenuItem value={formData.farmerId} key={0}>
                  {formData.farmerName}
                </MenuItem>
              )}
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SAYURAN
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="vegetableId"
              value={formData.vegetableId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.vegetableName && formData.vegetableId.length > 0 && (
                <MenuItem value={formData.vegetableId} key={0}>
                  {formData.vegetableName}
                </MenuItem>
              )}
              {vegetable.docs.length > 0 ? (
                vegetable.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.vegetableName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TANGGAL TANAM
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              type="date"
              error={false}
              value={formData.plantingDate}
              name="plantingDate"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TANGGAL ESTIMASI PANEN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              type="date"
              error={false}
              value={formData.estimatedDate}
              name="estimatedDate"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              JUMLAH ESTIMASI PANEN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              type="number"
              size="small"
              name="amountEstimated"
              value={formData.amountEstimated}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              LUAS AREA
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              type="number"
              size="small"
              name="plantingArea"
              value={formData.plantingArea}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/estimasi-panen")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
